module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#rss",
      toString: function () {
        return this.url;
      }
    }